import * as Yup from "yup"
import { useFormik } from "formik"
import type { FormikProps } from "formik"

import type { FilterCondition } from "../../../../types/custom/rules"
import type { ConditionListFile } from "../../../../types/generated/api/ConditionListFile"
import { levelSchema } from "../../../../utils/conditionHelpers"
import { EMPTY_FILTER_CONDITION } from "../../fixtures/workflow-fixtures"
import type { FilterFormikValues } from "../../types/interfaces"

interface UseFilterNodeFormProps {
  data?: {
    rules?: FilterCondition[]
    filesCount?: number
    fileData?: { name: string; uuid: string; version: string }
    condition_list_files?: ConditionListFile[] | null
  }
}

// Constants
const validationSchema = Yup.object({ rules: Yup.array().of(levelSchema) })

/**
 * useFilterNodeForm hook that manages form state for filter node configuration.
 * Handles validation, initial values, and form submission for filter conditions.
 */
export const useFilterNodeForm = ({ data }: UseFilterNodeFormProps): FormikProps<FilterFormikValues> => {
  return useFormik<FilterFormikValues>({
    validationSchema: validationSchema,
    validateOnMount: true,
    initialValues: {
      rules: data?.rules || [EMPTY_FILTER_CONDITION],
      filesCount: data?.filesCount ?? 0,
      fileData: data?.fileData || { name: "", uuid: "", version: "" },
      condition_list_files: data?.condition_list_files,
      parentLoopsFeatureList: [],
    },
    onSubmit: (_, { resetForm }) => {
      resetForm()
    },
  })
}
